import i18n from '@/i18n';

const BRAND = 'PT TEF';
const NOINDEX_ROUTES = ['profile', 'login', 'IndexApp', 'landing', 'admin.blog', 'admin.blog.create', 'admin.blog.edit', 'admin.careers', 'admin.careers.create', 'admin.careers.edit', 'admin.factoryRequest', 'admin.seminar'];

function toNamespace(routeName) {
  if (!routeName) return null;
  return routeName.charAt(0).toLowerCase() + routeName.slice(1);
}

function setMetaTag(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function updateHead(route) {
  if (!route) return;
  const ns = toNamespace(route.name);
  let title = BRAND;
  let description = '';

  if (ns) {
    const t = i18n.t(`${ns}.pageTitle`);
    const d = i18n.t(`${ns}.metaDescription`);
    if (typeof t === 'string' && t !== `${ns}.pageTitle`) {
      title = `${t} | ${BRAND}`;
    }
    if (typeof d === 'string' && d !== `${ns}.metaDescription`) {
      description = d;
    }
  }

  document.title = title;
  setMetaTag('name', 'description', description);
  setMetaTag('property', 'og:title', title);
  setMetaTag('property', 'og:description', description);
  setMetaTag('name', 'twitter:title', title);
  setMetaTag('name', 'twitter:description', description);
  setMetaTag('name', 'robots', NOINDEX_ROUTES.includes(route.name) ? 'noindex, nofollow' : 'index, follow');

  const canonicalUrl = `https://tef.co.id${route.path}`;
  let canonicalEl = document.querySelector('link[rel="canonical"]');
  if (!canonicalEl) {
    canonicalEl = document.createElement('link');
    canonicalEl.setAttribute('rel', 'canonical');
    document.head.appendChild(canonicalEl);
  }
  canonicalEl.setAttribute('href', canonicalUrl);
  setMetaTag('property', 'og:url', canonicalUrl);
}

// Overrides the generic route-level head (from updateHead) with the specific
// article's own title/description/image once its data has loaded. Called after
// updateHead so it must re-set the same title/description/og/twitter tags.
export function updateArticleHead({ title, description, imageUrl }) {
  if (!title) return;
  const fullTitle = `${title} | ${BRAND}`;
  const plainText = (description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  const excerpt = plainText.length > 160 ? plainText.slice(0, 157) + '...' : plainText;

  document.title = fullTitle;
  setMetaTag('name', 'description', excerpt);
  setMetaTag('property', 'og:title', fullTitle);
  setMetaTag('property', 'og:description', excerpt);
  setMetaTag('name', 'twitter:title', fullTitle);
  setMetaTag('name', 'twitter:description', excerpt);
  if (imageUrl) {
    setMetaTag('property', 'og:image', imageUrl);
    setMetaTag('name', 'twitter:image', imageUrl);
  }
}
